import React, { useState, useEffect, useRef } from 'react';
import './StatusFilterDropdown.css';

function StatusFilterDropdown(props) {
	const {
		onFilter,
		filteredStatus,
		statuses,
		isDisabled,
	} = props;

	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleSelect = (status) => {
		onFilter(status);
		setIsOpen(false);
	};

	const getDisplayText = (status) => {
		if (status === 'all') return 'All';
		if (status === 'other') return 'Other';
		return status;
	};

	const getButtonClass = () => {
		if (filteredStatus === 'all') return 'btn-success';
		return 'btn-primary';
	};

	return (
		<div className="status-filter-dropdown" ref={dropdownRef}>
			<button
				disabled={isDisabled}
				className={`filter-button btn btn-sm ${getButtonClass()} dropdown-toggle px-2`}
				onClick={() => setIsOpen(!isOpen)}
			>
				Status: {getDisplayText(filteredStatus)}
				<span className="caret"></span>
			</button>
			{isOpen && (
				<div className="status-filter-menu">
					<div
						className={`status-filter-item ${filteredStatus === 'all' ? 'active' : ''}`}
						onClick={() => handleSelect('all')}
					>
						All
					</div>
					{statuses.map((status) => (
						<div
							key={status}
							className={`status-filter-item ${filteredStatus === status ? 'active' : ''}`}
							onClick={() => handleSelect(status)}
						>
							{status}
						</div>
					))}
					<div
						className={`status-filter-item ${filteredStatus === 'other' ? 'active' : ''}`}
						onClick={() => handleSelect('other')}
					>
						Other
					</div>
				</div>
			)}
		</div>
	);
}

export default StatusFilterDropdown;